
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";
    import {
      ApplicationActions,
      MakeRequirementProcessingDecisionRequest,
      ProcessingDecisionType,
      RequirementFulfillmentStatus,
      RequirementFulfillmentViewModel,
      RequirementsClient,
    } from "@/api-client";
    import ConfirmWithCommentModal from "@/features/shared/components/ConfirmWithCommentModal.vue";

    @Component({
        components: {
          ConfirmWithCommentModal
        }
    })
    export default class RequirementProcessing extends Vue {
        @Prop({required: true})
        applicationId!: string;

        @Prop({required: true})
        actions!: ApplicationActions;

        @Prop({required: true})
        requirementFulfillment!: RequirementFulfillmentViewModel;

        @Prop({default: false})
        isInEditMode!: boolean;

        @Prop({required:true})
        requirement!: string;

        @Prop({required:true})
        seafarerId!: string;

        Status = RequirementFulfillmentStatus; 
      
        $refs!: { rejectModal: ConfirmWithCommentModal }

        accept() {
            new RequirementsClient().decide(new MakeRequirementProcessingDecisionRequest({
                comment: "",
                requirementDecision: ProcessingDecisionType.Accepted
            }), this.applicationId, this.requirementFulfillment!.requirementId).then(
                () => this.$emit("application-changed"),
                error => this.$emit("error-happened", error)
            );
        }

        reject(comment: string) {
            new RequirementsClient().decide(new MakeRequirementProcessingDecisionRequest({
                comment: comment,
                requirementDecision: ProcessingDecisionType.Rejected
            }), this.applicationId, this.requirementFulfillment!.requirementId).then(
                () => this.$emit("application-changed"),
                error => this.$emit("error-happened", error)
            );
        }
    }
